import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../utility';

const initialState = {
    adult: 1,
    child: 0,
    infant: 0,
    adultActive: true,
    childActive: false,
    infantActive: false
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SET_ADULT:
            if(action.val < state.infant) {
                return updateObject(state, {adult: action.val, infant: 0});
            } 
            return updateObject(state, {adult: action.val})
        case actionTypes.SET_CHILD:
            return updateObject(state, {child: action.val})
        case actionTypes.SET_INFANT:
            return updateObject(state, {infant: action.val})
        case actionTypes.CLICK_FLIGHT_ADULT:
            return updateObject(state, {adultActive: true, childActive: false, infantActive: false})
        case actionTypes.CLICK_FLIGHT_CHILD:
            return updateObject(state, {adultActive: false, childActive: true, infantActive: false})
        case actionTypes.CLICK_FLIGHT_INFANT:
            return updateObject(state, {adultActive: false, childActive: false, infantActive: true})
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/travellers.js